import React from "react";
import { Youtube } from "lucide-react";
import "./CrudPageHeader.scss";

const DEFAULT_TUTORIAL_URL = "https://www.youtube.com/@Accountree";

export default function CrudPageHeader({
  icon: Icon,
  title,
  description,
  tutorialUrl,
  tutorialLabel = "Shiko Tutorialin",
  onTutorialClick,
  action,
  className = "",
}) {
  const resolvedTutorialUrl = tutorialUrl || DEFAULT_TUTORIAL_URL;

  const handleTutorialClick = (event) => {
    if (onTutorialClick) {
      onTutorialClick(event);
    }
  };

  const hasTutorial = Boolean(tutorialUrl || onTutorialClick);

  return (
    <section className={`CPH__header ${className}`.trim()}>
      <div className="CPH__identity">
        {Icon && (
          <div className="CPH__icon-box">
            <Icon size={24} color="#284945" />
          </div>
        )}

        <div className="CPH__texts">
          <h1>{title}</h1>
          {description ? <p>{description}</p> : null}
        </div>
      </div>

      <div className="CPH__controls">
        {hasTutorial && (
          <a
            href={resolvedTutorialUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="CPH__tutorial-link"
            onClick={handleTutorialClick}
          >
            <Youtube size={16} />
            {tutorialLabel}
          </a>
        )}

        {action ? <div className="CPH__action-slot">{action}</div> : null}
      </div>
    </section>
  );
}
